<template>
  <div class='personals' v-loading="loading">
    <el-tabs class="tabs_card" v-model="activeName" type="card" @tab-click="handleTabClick">
      <el-tab-pane label="个人信息" name="1">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="ruleForm">
          <el-row>
            <el-col :span="24">
              <el-form-item class="avatar_wrap" label="头像" prop="headPic">
                <el-image class="avatar" :src="ruleForm.headPic" fit="cover"></el-image>
                <el-upload class="upload_demo" accept=".png,.jpeg,.jpg" :file-list="fileList" :limit='1' name="multipartFile" :action="action" :on-success="handleSuccess" :before-upload="beforeUploads" :on-remove="handleRemove" list-type="picture" :show-file-list="false" :disabled="ruleForm.headPic ? true : false">
                  <el-button type="" size="mini" plain>修改头像</el-button>
                </el-upload>
                <i v-if="ruleForm.headPic" class="delpic el-icon-error" @click="handleRemove"></i>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7">
              <el-form-item label="姓名" prop="userName">
                <el-input v-model="ruleForm.userName" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="出生日期" prop="birthDate">
                <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.birthDate" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
              <el-form-item label="籍贯" prop="nativePlace">
                <el-input v-model="ruleForm.nativePlace" placeholder="请输入籍贯"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="性别" prop="userSex">
                <el-select v-model="ruleForm.userSex" placeholder="请选择性别">
                  <el-option label="女" value="0"></el-option>
                  <el-option label="男" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="身份证" prop="identityCard">
                <el-input v-model="ruleForm.identityCard" placeholder="请输入身份证"></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="userPhone">
                <el-input v-model="ruleForm.userPhone" placeholder="请输入联系电话"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="修改密码" name="2">
        <el-form :model="passForm" :rules="passRules" ref="passForm" label-width="150px" class="demo-passForm">
          <div class="pass_wrap">
            <el-form-item label="新的密码" prop="password">
              <el-input v-model="passForm.password" placeholder="请输入新的密码" show-password></el-input>
              <el-tooltip content="密码至少8位数且必须包含大写字母、小写字母、数字" placement="top" effect="light">
                <i class="el-icon-warning-outline tips"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input v-model="passForm.confirmPassword" placeholder="请输入确认密码" show-password></el-input>
            </el-form-item>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <div class="btn_wrap">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm(activeName == '1' ? 'ruleForm' : 'passForm')">确 定</el-button>
    </div>
  </div>
</template>

<script>
function createInitRuleForm () {
  return {
    userName: '',
    userSex: '',
    birthDate: '',
    departmentId: '',
    identityCard: '',
    userPhone: '',
    nativePlace: '',
    headPic: '',
    headPicId: '',
  }
}
export default {
  data () {
    // 正则表达式验证身份证的格式  
    var validateIdCard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('身份证不能为空'));
      }
      const idCardRegex = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}([0-9]|X)$/;
      if (!idCardRegex.test(value)) {
        callback(new Error('身份证格式不正确'));
      } else {
        callback();
      }
    };
    var checkTel = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('联系电话不能为空'));
      }
      const telRegex = /^(?:(?:\+|00)86)?1\d{10}$/;
      if (!telRegex.test(value)) {
        callback(new Error('联系电话格式不正确'));
      } else {
        callback();
      }
    };
    return {
      obj: {},
      avatar: require('@/assets/img/avatar.png'),
      activeName: '1',
      dialogTitle: '个人信息',
      dialogVisible: false,
      loading: false,
      fileList: [],
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
      ruleForm: createInitRuleForm(),
      passForm: { password: '', confirmPassword: '' },
      passRules: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur", },
          {
            min: 8,
            message: '密码格式不正确',
            validator: (rule, value, callback) => {
              if (!/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(value)) {
                callback(new Error('密码必须包含大写字母、小写字母、数字'));
              } else {
                callback();
              }
            },
            trigger: ['blur', 'change'],
          },
        ],
        confirmPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.passForm.password) {
                callback(new Error('两次输入的密码不一致!'));
              } else {
                callback();
              }
            },
            trigger: ['blur', 'change'],
          },
        ],
      },
      rules: {
        userName: [{ required: true, message: '请输入姓名', trigger: 'submit' }],
        userSex: [{ required: true, message: '请选择性别', trigger: 'submit' }],
        birthDate: [{ required: true, message: '请选择日期', trigger: 'submit' }],
        nativePlace: [{ required: true, message: '请输入籍贯', trigger: 'submit' }],
        userPhone: [{ required: true, validator: checkTel, trigger: 'submit' }],
        identityCard: [{ required: true, validator: validateIdCard, trigger: 'submit' }],
      },
    }
  },
  created () {
    this.obj = this.$store.state.userInfo;
  },
  methods: {
    // 个人信息
    getInformation () {
      this.loading = true
      this.$axios.get(this.$api.getInformation).then((res) => {
        if (res.code == 100) {
          this.ruleForm = res.result
        }
        this.loading = false
      });
    },
    handleTabClick () {
      if (this.activeName == '1') {
        this.dialogTitle = '个人信息'
        this.getInformation()
      } else {
        this.dialogTitle = '修改密码'
      }
    },
    handleClose () {
      this.dialogTitle = null
      this.resetForm();
      this.dialogVisible = false
    },
    handleConfirm (formName) {
      let params = this.activeName == '1' ? Object.assign({}, this.ruleForm) : Object.assign({}, this.passForm)
      let api = this.activeName == '1' ? this.$api.updateInformation : this.$api.updatePassword
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post(api, params).then((res) => {
            if (res.code == 100) {
              this.$message.success(res.desc)
              this.getInformation();
              if (this.activeName == '1') {
                this.$store.dispatch('updateUserInfos', {
                  userName: params.userName,
                  userSex: params.userSex,
                  birthDate: params.birthDate,
                  departmentId: params.departmentId,
                  identityCard: params.identityCard,
                  userPhone: params.userPhone,
                  nativePlace: params.nativePlace,
                  headPic: params.headPic,
                  headPicId: params.headPicId,
                })
                this.obj = this.$store.state.userInfo;
              }
            }
            this.fileList = []
          }).catch((err) => {
            this.fileList = []
            this.$message.error(err.data.desc);
          });
        } else {
          this.$message.error("提交失败");
          return false;
        }
      });
    },
    // 重置校验
    resetForm () {
      if (this.activeName == '1') {
        this.ruleForm = createInitRuleForm();
        this.$refs.ruleForm.resetFields();
      } else {
        this.passForm = { password: '', confirmPassword: '' }
        this.$refs.passForm.resetFields();
      }
    },
    // 文件上传
    beforeUploads (file) {
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isLt5M;
    },
    // 删除文件
    handleRemove () {
      this.ruleForm.headPic = "";
      this.ruleForm.headPicId = "";
      this.fileList = []
    },
    // 上传成功
    handleSuccess (res) {
      if (res.code == 100) {
        this.ruleForm.headPicId = res.result.fileId;
        this.ruleForm.headPic = res.result.fileUrl;
      } else {
        this.$message({ showClose: true, message: res.desc, type: "error", });
      }
    },
  },
}
</script>

<style scoped lang='scss'>
.personals {
  .tabs_card {
    ::v-deep .el-tabs__header {
      margin: 0 0 30px;
      border-bottom: none;
    }

    ::v-deep .el-tabs__nav {
      border: 1px solid #E4E7ED;
      border-radius: 10px;
      overflow: hidden;

      .is-active {
        color: #fff;
        background-color: $themes;
      }
    }

    ::v-deep .el-tabs__item {
      color: #606266;
      border-bottom: none;
      background-color: #fff;
      transition: none;
    }

    .ruleForm {

      .el-select,
      .el-date-editor {
        display: block;
        width: 100%;
      }
    }

    .avatar_wrap {
      position: relative;

      ::v-deep .el-form-item__label {
        height: 100px;
        line-height: 100px;
      }

      ::v-deep .el-form-item__content {
        display: flex;
        align-items: center;
        height: 100px;
      }

      .el-button {
        margin-left: 20px;
      }

      .avatar {
        display: block;
        width: 100px;
        height: 100px;
        border-radius: 50px;
      }

      .delpic {
        position: absolute;
        top: 0;
        right: 200px;
        color: red;
        font-size: 20px;
        cursor: pointer;
      }
    }

    .pass_wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 500px;
      margin: 0 auto;

      .tips {
        position: absolute;
        top: 50%;
        right: -20px;
        transform: translateY(-50%);
        color: #C0C4CC;
        cursor: pointer;
      }
    }
  }

  .btn_wrap {
    text-align: center;
    margin-top: 40px;
  }
}
</style>
